import { GET_ADDRESS_TREE } from '@package/actions';

const initialState = {
  error: null,
  hasError: false,
  result: {},
  loading: false,
  loaded: false,
};

export const addressTreeReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_ADDRESS_TREE}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
      };

    case `${GET_ADDRESS_TREE}_SUCCESS`:
      return {
        ...state,
        result: action.result,
        loading: false,
        loaded: true,
      };

    case `${GET_ADDRESS_TREE}_FAIL`:
      return {
        ...state,
        error: action.error,
        hasError: true,
        loading: false,
        loaded: true,
      };

    default:
      return state;
  }
};
